import React, { useEffect, useState } from "react";
import { Button, Modal, Radio } from "antd";
import PropagateLoader from "react-spinners/PropagateLoader";
import DataTable from "react-data-table-component";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import { useHistory } from "react-router-dom";
import {
  POST_PAYOUT_GET_BENEFICIARY,
  POST_PAYOUT_INITIATED_TRANSACTION,
  POST_PAYOUT_V2_ADD_BENEFICIARY,
  POST_PAYOUT_UPDATE_STATUS_BENEFICIARY,
  POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL,
  GET_DMT_NEW_BANK_LIST,
  GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER,
  IFSC_CODE_VERIFY,
  GET_NAME,
  RE_CHECK,
  POST_BENE_BANK_ACCOUNT_LIMIT,
} from "../../Utils/appConstants";
import { getRequest, postRequest } from "../../Utils/AppApi";
import { ToastContainer, toast } from "react-toastify";
import { isNumber, isAlphabetOnly } from "../../Utils/Common";
import {
  refId,
  isIfscCodeValid,
  getUTCToLocalDateFormat,
} from "./../../Utils/function";
import PayoutInvoice from "./../../container/payoutInvoice";
import Select from "react-select";

function Beneficiarylist(props) {
  // console.log("props -------",props.search)
  // const user = getUser();
  const history = useHistory();
  // const csvLink = useRef();
  const limit = 10;
  const [getData, setData] = useState([]);
  const [isLimit, setLimit] = useState(limit);
  const [page, setPage] = useState(1);
  const [saveCustomerMobile, setCustomerMobile] = useState(
    props.customerData && props.customerData.customerMobile
  );
  const [saveCustomerAutoId, setCustomerAutoId] = useState(
    props.customerData && props.customerData._id
  );
  const [saveCustomerName, setCustomerName] = useState(
    props.customerData && props.customerData.customerName
  );
  const [isLoading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [getDataField, setDataField] = useState({});
  const [timer, setTimer] = useState(null);
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [bankId, setBankId] = useState(null);
  const [bankName, setBankName] = useState("");
  const [isAddBaneModal, setAddBaneModal] = useState(false);
  const [isSendMoneyModal, setSendMoneyModal] = useState(false);
  const [isSendButtonDisable, setSendButtonDisable] = useState(true);
  const [isSelectedUser, setIsSelectedUser] = useState({});

  const [invoiceDataModal, setInvoiceDataModal] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);
  const [sendMoneyAmount, setSendMoneyAmount] = useState(null);
  const [getBeneData, setBeneData] = useState({});
  const [getBeneError, setBeneError] = useState({});
  const [getEKOBankListData, setEKOBankListData] = useState([]);
  const [getBankListData, setBankListData] = useState([
    { value: "", label: "-- Select Bank --" },
  ]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isIfscEnable, setIfscEnable] = useState(false);
  const [aadharVerifyModal, setAadharVerifyModal] = useState(false);
  const [aadharVerifyDetail, setAadharVerifyDetail] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [beneAccountLimit, setBeneAccountLimit] = useState(25000);

  const [selectedRelation, setSelectedRelation] = useState("");

  const relations = [
    "Self",
    "Father",
    "Mother",
    "Husband",
    "Wife",
    "Son",
    "Daughter",
    "Brother",
    "Sister",
    "Grandfather",
    "Grandmother",
    "Uncle",
    "Aunt",
    "Cousin Brother",
    "Cousin Sister",
    "Brother-in-law",
    "Sister-in-law",
    "Father-in-law",
    "Mother-in-law",
    "Son-in-law",
    "Daughter-in-law",
    "Friend",
    "Other",
  ];

  const columns = [
    {
      name: "Nick Name",
      selector: (row) => (
        <>
          <div>{row.beneName}</div>
          {row.beneMobile && (
            <div>
              <strong>Mobile</strong>: {row.beneMobile}
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "IFSC / Bank",
      selector: (row) => (
        <>
          <div>
            <strong>IFSC</strong>: {row.ifscCode}
          </div>
          {row.bankName && (
            <div>
              <strong>Bank</strong>: {row.bankName}
            </div>
          )}
        </>
      ),
      width: "200px",
    },
    {
      name: "Account",
      selector: (row) => (
        <>
          <div>{row.accountNumber}</div>
          <div>
            <strong>UP</strong>: {getUTCToLocalDateFormat(row.updatedAt)}
          </div>
        </>
      ),
      width: "150px",
    },
    {
      name: "Bene Name",
      selector: (row) => (
        <>
          <div>
            <strong>
              {row.isVerified ? (
                <CheckOutlined className="text-120 text-success border p-1" />
              ) : (
                <CloseOutlined className="text-120 text-danger border p-1" />
              )}
            </strong>{" "}
            {row.beneBankName}{" "}
          </div>
        </>
      ),
      width: "200px",
    },
    {
      name: "Verified",
      selector: (row) => (
        <>
          {row.isVerified ? (
            <button
              onClick={() => getName(row, true)}
              className={`pointer text-success`}
              disabled={row.isActive ? false : true}
            >
              {RE_CHECK}
            </button>
          ) : (
            <button
              onClick={() => getName(row, false)}
              className={`pointer text-danger`}
              disabled={row.isActive ? false : true}
            >
              {GET_NAME}
            </button>
          )}
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => (
        !row.beneficiary_id || row.beneficiary_id.trim() === "" ? (
          // If beneficiary_id is null or empty, display "Deactive" and disable the button
          <button
            className="pointer text-danger"
            disabled
            style={{ whiteSpace: 'normal', wordWrap: 'break-word', maxWidth: '100px' }}
          >
          Bene ID Missing
          </button>
        ) : row.isActive ? (
          // If beneficiary_id exists and is active, display "Active" button
          <button
            onClick={() => beneStatus(row, false)} // Deactivate
            className="pointer text-success"
          >
            Active
          </button>
        ) : (
          // If beneficiary_id exists and is inactive, display "Deactive" button
          <button
            onClick={() => beneStatus(row, true)} // Activate
            className="pointer text-danger"
          >
            Deactive
          </button>
        )
      ),
      width: "100px",
    },
    {
      name: "Amount",
      selector: (row, index) => (
        <>
          <input
            type="text"
            name="amount"
            className="form-control"
            onChange={(e) => handleEditRowAmount(e, index)}
            placeholder="Amount"
            onKeyDown={isNumber}
            maxLength={5}
            disabled={row.isActive ? false : true}
          />
        </>
      ),
      width: "120px",
    },
  {
       name: "Action",
       selector: (row) => (
         <>
           <Button
             className={"bg-primary"}
             onClick={() => sendMoney(row)}
             disabled={row.isActive ? isSendButtonDisable : true}
             small
           >
             Send
           </Button>
         </>
       ),
       width: "150px",
       fixed: "right",
     },
     
  ];

  useEffect(() => {
    // console.log("props.customerData.customerMobile ---" ,props.customerData)
    setCustomerMobile(props.customerData && props.customerData.customerMobile);
    setCustomerAutoId(props.customerData && props.customerData._id);
    setCustomerName(props.customerData && props.customerData.customerName);
  }, [props.customerData]); // eslint-disable-line react-hooks/exhaustive-deps

  const beneStatus = (data, status) => {
    let params = {};
    params.id = data._id;
    params.status = status;
    postRequest(POST_PAYOUT_UPDATE_STATUS_BENEFICIARY, params, history)
      .then((response) => {
        if (response.success === true) {
          getDataReports();
        }
        toast.success(response.message, {
          toastId: "success1",
        });
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const beneBankLimit = (account_Number, detailFor) => {
    let params = {};
    params.accountNumber = account_Number;
    params.detail_for = detailFor;
    postRequest(POST_BENE_BANK_ACCOUNT_LIMIT, params, history)
      .then((response) => {
        if (response.success === true) {
          setBeneAccountLimit(response.beneAccountLimit);
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const updateBeneData = (data) => {
    let params = {};
    params.id = data._id;
    params.beneBankName = data.beneBankName;
    postRequest(POST_PAYOUT_UPDATE_BENEFICIARY_DETAIL, params, history)
      .then((response) => {
        if (response.success === true) {
          getDataReports();
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const getBankList = () => {
    getRequest(GET_DMT_NEW_BANK_LIST, history)
      .then((response) => {
        if (response.success === true) {
          let bankDataRecord;
          if (response.data) {
            bankDataRecord = response.data.filter(
              (item) => item.key === "DMT1.0"
            );
          }
          setEKOBankListData(bankDataRecord);
          setBankListData([
            ...getBankListData,
            ...bankDataRecord.map((item) => {
              return { value: item.BankID, label: item.BANK_NAME };
            }),
          ]);
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
  };

  const onChangeBankIfscCode = (value) => {
    // console.log('value -----', value)
    if (value) {
      let findBank = getEKOBankListData.filter((item) => item.BankID === value);
      if (findBank.length > 0) {
        // console.log('findBank -----', findBank)
        setSelectedOption({
          value: findBank[0].BankID,
          label: findBank[0].BANK_NAME,
        });
        if (findBank[0].ifsc) {
          setBeneData({ ...getBeneData, ifscCode: findBank[0].ifsc });
          let obj = {};
          obj.target = { name: "ifscCode", value: findBank[0].ifsc };
          enterIfscCode(obj);
          setIfscEnable(true);
        } else {
          setBeneData({ ...getBeneData, ifscCode: "" });
          setIfscEnable(false);
        }
        // console.log('findBank[0].BankID -----', findBank[0].BankID)
        setBankId(findBank[0].BankID);
        setBankName(findBank[0].BANK_NAME);
      } else {
        setBankId(null);
      }
      // setBeneData({ ...getBeneData, ifscCode: value });
      // setIfscCodeModal(false)
    } else {
      setBankId(null);
      setIfscEnable(false);
      setBeneData({ ...getBeneData, ifscCode: "" });
      // setBeneData({ ...getBeneData, ifscCode: value });
    }
  };

  const enterIfscCode = async (event) => {
    let { name, value } = event.target;
    // console.log("event ------", event)
    setBeneData({ ...getBeneData, [name]: value });
    if (isIfscCodeValid(value)) {
      onChangeIfscCode(value);
      setBeneError({ ...getBeneError, ifscCodeVaild: 1 });
      // console.log("isAlphabetOnly IF------")
    } else {
      setBeneError({ ...getBeneError, ifscCodeVaild: 2 });
      // event.preventDefault();
    }
  };

  const handleEditRowAmount = (event, index) => {
    // console.log("event ---------------", event)
    // console.log("index ---------------", index)
    // console.log("getData ---------------", getData)
    let array = getData; //[...getData];
    array.docs[index].amount = event.target.value;
    const value = parseFloat(event.target.value); // Parse the value to number

    if (value < 500) {
      toast.error("Minimum amount is: 500", {
        toastId: "error_min",
      });
      setSendButtonDisable(true);
      event.preventDefault();
      return false;
    } else if (value > 10000) {
      toast.error("Maximum amount is: 10000", {
        toastId: "error_max",
      });
      setSendButtonDisable(true);
      event.preventDefault();
      return false;
    } else {
      // Only enable the send button if value is within the valid range
      setSendButtonDisable(value < 1); // Disable if value is less than 1
      setData(array); // Ensure 'array' is defined and contains the correct data
    }

    // setSendButtonDisable(value < 1); // Disable if value is less than 1
    //   setData(array);
  };

  const handleAmount = (event) => {
    setSendMoneyAmount(event.target.value);
    // console.log("object ---------------", object)
  };

  const onChangeAddBeneName = async (event) => {
    let { name, value } = event.target;
    // console.log("isAlphabetOnly 2 name------", name)
    // console.log("isAlphabetOnly value ------", value)
    // console.log("isAlphabetOnly ------", typeof isAlphabetOnly(value))
    if (isAlphabetOnly(value)) {
      // console.log("isAlphabetOnly IF------")
      setBeneData({ ...getBeneData, [name]: value });
    } else {
      event.preventDefault();
    }
  };

  const onChangeAddBene = (event) => {
    let { name, value } = event.target;
    // console.log("isAlphabetOnly 1 name------", name)
    setBeneData({ ...getBeneData, [name]: value });
  };

  const sendMoney = (row) => {
    // console.log("row ---------------", row)

    if (!row.beneficiary_id?.trim()) {
      toast.error("Beneficiary ID is missing. Please contact SR PAY Support Team");
      return false;
    } 

    if (!row.amount) {
      toast.error("Amount is empty");
      return false;
    }
    setSendMoneyModal(true);
    row.isChannel = isSelectedUser.isChannel?isSelectedUser.isChannel:"4";
    setIsSelectedUser(row);

    beneBankLimit(row.accountNumber, "quickSettlement");

    // const payload = {
    //     customer_id: saveCustomerMobile,
    //     // recipient_id: data.beneId,
    //     accountNumber: row.accountNumber,
    //     ifsccode: row.ifscCode,
    //     beneAutoId: row._id,
    //     amount: row.amount,
    //     channel: row.isChannel,
    //     latitude: latitude,
    //     longitude: longitude,
    //     serviceName: "DMT1"
    // }
    // handleConfirmSubmit(payload);
  };

  // const handleConfirmSubmit = (data) => {
  //     setLoading(true)
  //     postRequest(`${POST_DMT_PAY_SPRINT_CONFIRM_INITIATE_TRANSACTION}`, data, history).then((response) => {
  //         if (response.success === true) {
  //             setChargesData(response.data);
  //         } else {
  //             setSendMoneyModal(false)
  //             toast.error(response.message);
  //         }
  //         setLoading(false);
  //     }).catch(function (error) {
  //         // console.log(error)
  //         setLoading(false);
  //     });
  // }

  const handleSyncBeneficiary = () => {
    getDataReports();
  };

  const handleSave = (data) => {
    if (sendMoneyAmount !== data.amount) {
      toast.error("Amount did not matched.");
    } else {
      const payload = {
        customerAutoId: saveCustomerAutoId,
        customerName: saveCustomerName,
        beneAutoId: data._id,
        baneName: data.beneName,
        accountNumber: data.accountNumber,
        ifsccode: data.ifscCode,
        amount: sendMoneyAmount,
        channel: data.isChannel,
        apiName: "PAYOUTV2",
        latitude: latitude,
        longitude: longitude,
        detail_for: "quickSettlement",
      };
      handleSubmit(payload);
    }
  };

  const handleSubmit = async (data) => {
    setLoading(true);
    await postRequest(`${POST_PAYOUT_INITIATED_TRANSACTION}`, data, history)
      .then((response) => {
        if (response.success === true) {
          handleHideModal();
          getDataReports();

          history.push("/PayoutHistory2");

          // handleInvoice(response.data);
          toast.success(response.message);
        } else {
          toast.error(response.message);
        }
        setSendMoneyAmount(null);

        setLoading(false);
      })
      .catch(function (error) {
        // console.log(error)
        setLoading(false);
        handleHideModal();
      });
  };

  const handleInvoice = (data) => {
    setInvoiceDataModal(true);
    setInvoiceData(data);
  };

  const handleInvoiceModal = () => {
    setInvoiceDataModal(false);
  };

  const addBane = () => {
    setAddBaneModal(true);
    setBeneData({});
    setDataField({});
  };

  const FormBaneValidate = () => {
    let formValid = true;
    let formObject = {};
    setBeneError({});
    if (getBeneData && getBeneData.length === 0) {
      formValid = false;
    }
    let array = ["mobile", "name", "ifscCode", "accountNumber"];
    array.forEach((element) => {
      if (
        getBeneData[element] === "" ||
        typeof getBeneData[element] === "undefined"
      ) {
        formObject[element] = true;
        formValid = false;
      }
    });

    setBeneError(formObject);
    return formValid;
  };

  const addBaneSave = () => {
    // console.log("-------------- Save")
    // console.log("-------------- getBeneData",getBeneData)
    if (FormBaneValidate() === true) {
      // console.log("SAVE-------------- getBeneData",getBeneData)
      const payload = {
        customerMobile: saveCustomerMobile,
        recipientMobile: getBeneData.mobile,
        accountNumber: getBeneData.accountNumber,
        ifscCode: getBeneData.ifscCode,
        bankId: bankId,
        bankName: bankName,
        recipientName: getBeneData.name,
        beneBankName: getBeneData.beneBankName,
        apiName: "PAYOUTV2",
        latitude: latitude,
        longitude: longitude,
        isRemittanceBene: false,
      };
      setLoading(true);
      postRequest(`${POST_PAYOUT_V2_ADD_BENEFICIARY}`, payload, history)
        .then((response) => {
          if (response.success === true) {
            toast.success(response.message);
            getDataReports();
            setBeneData({});
            setAddBaneModal(false);
            // setBeneficiaryId(response.data.beneficiaryId);
          } else {
            toast.error(response.message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          // console.log(error)
          setLoading(false);
        });
    }
  };

  // const importBaneficiarySave = (data) => {
  //     // console.log("-------------- Save")
  //     // console.log("-------------- getBeneData",getBeneData)
  //     if (data) {
  //         // console.log("SAVE-------------- getBeneData",getBeneData)
  //         let payload = data;
  //         payload.beneficiaryMobileNumber = data.recipientMobile;
  //         setLoading(true)
  //         postRequest(`${POST_PAYOUT_V2_ADD_BENEFICIARY}`, payload, history).then((response) => {
  //             if (response.success === true) {
  //                 // setImportModal(false);
  //                 if (response.isotp === true) {
  //                     setOtpModal(true);
  //                 } else {
  //                     getDataReports();
  //                     setBeneData({});
  //                     setAddBaneModal(false)
  //                 }

  //                 setReferenceKey(response.data.referenceKey);
  //                 setBeneficiaryId(response.data.beneficiaryId);
  //                 toast.success(response.message);
  //             } else {
  //                 toast.error(response.message);
  //             }
  //             setLoading(false)
  //         }).catch(function (error) {
  //             // console.log(error)
  //             setLoading(false)
  //         })
  //     }
  // }

  const handleHideModal = () => {
    setSendMoneyModal(false);
    setAddBaneModal(false);
  };

  const objectToQueryString = (obj) => {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  };

  const params = { page: page, limit: isLimit };

  const getDataReports = (data) => {
    if (data) {
      setLimit(data);
      params.limit = data;
    }
    if (searchText) {
      params.search = searchText;
    }
    if (props.customerData && props.customerData.customerMobile) {
      params.customerMobile = props.customerData.customerMobile;
      setCustomerMobile(params.customerMobile);
    }
    const queryString = objectToQueryString(params);
    getRequest(`${POST_PAYOUT_GET_BENEFICIARY}?${queryString}`, history)
      .then((response) => {
        if (response.success === true) {
          setData(response.data);
          // setTotalRecord(response.data.totalDocs);
          // setPage(response.data.page);
        } else {
          // setData([]);
          // setTotalRecord(0);
          setPage(1);
        }
      })
      .catch(function (error) {
        // console.log(error)
        // setLoading(false);
      });
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const getName = (data, recheck) => {
    if (data.accountNumber && data.ifscCode) {
      // console.log("--- Valid", getBeneData)
      setLoading(true);
      const payload = {
        ifsccode: data.ifscCode,
        accountNumber: data.accountNumber,
        externalRef: refId(13),
        consent: "Y",
        pennyDrop: "AUTO",
        recheck: recheck,
        latitude: latitude,
        longitude: longitude,
      };
      postRequest(
        `${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`,
        payload,
        history
      )
        .then((response) => {
          if (response.success === true) {
            // console.log("response.data-----------", response.data.data)
            let record = response.data.data;
            // let Object = { "beneBankName": record.nameAtBank }
            setAadharVerifyModal(true);
            setAadharVerifyDetail(response.data);
            data.beneBankName = record.nameAtBank;
            updateBeneData(data);
          } else {
            // console.log("response.data-----------", response)
            toast.error(response.message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
          // console.log(error)
        });
    }
  };

  const getBankNameFromAccountNumber = () => {
    // setSeconds(60);
    if (getBeneData.accountNumber && getBeneData.ifscCode) {
      setLoading(true);
      // console.log("--- Valid", getBeneData)
      const payload = {
        ifsccode: getBeneData.ifscCode,
        accountNumber: getBeneData.accountNumber,
        externalRef: refId(13),
        consent: "Y",
        pennyDrop: "AUTO",
        latitude: latitude,
        longitude: longitude,
      };
      postRequest(
        `${GET_CUSTOMER_BANK_NAME_FROM_ACCOUNT_NUMBER}`,
        payload,
        history
      )
        .then((response) => {
          if (response.success === true) {
            // console.log("response.data-----------", response.data.data)
            let record = response.data.data;
            let Object = { beneBankName: record.nameAtBank };
            setBeneData({ ...getBeneData, ...Object });
          } else {
            // console.log("response.data-----------", response)
            toast.error(response.message);
          }
          setLoading(false);
        })
        .catch(function (error) {
          // console.log(error)
          setLoading(false);
        });
    } else {
      toast.error("Please enter valid account number");
      let Object = { name: "" };
      setBeneData({ ...getBeneData, ...Object });
    }
  };

  const onChangeIfscCode = (val = null) => {
    let value;
    if (val) {
      value = val;
    } else {
      value = getBeneData && getBeneData.ifscCode;
    }
    if (isIfscCodeValid(value)) {
      // console.log("--- Valid", value)
      const payload = { ifsccode: value };
      postRequest(`${IFSC_CODE_VERIFY}`, payload, history)
        .then((response) => {
          if (response.success === true) {
            // console.log("response.data-----------", response.data.data)
            let record = response.data.data;
            let Object = {
              ifscCode: record.ifsc,
              address: record.address,
              bankName: record.bank,
              branchAddress: record.branch,
              city: record.city,
              state: record.state,
            };
            setDataField(Object);
          } else {
            // console.log("response.data-----------", response)
          }
        })
        .catch(function (error) {
          // console.log(error)
        });
    } else {
      if (value && value.length === 11) {
        toast.error("Please enter valid ifsccode");
        let Object = {
          address: "",
          bankName: "",
          branchAddress: "",
          city: "",
          state: "",
        };
        setDataField(Object);
      }
    }
  };

  const handleSearch = (e) => {
    // console.log("searchText----",e.target.value)
    setSearchText(e.target.value);
  };

  const onChangeChannel = ({ target: { value } }) => {
    // console.log("value-------------- value", value)
    let isSelectedUserValue = { ...isSelectedUser };
    isSelectedUserValue.isChannel = value;
    setIsSelectedUser(isSelectedUserValue);
  };

  useEffect(() => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    setTimer(
      setTimeout(() => {
        getDataReports();
      }, 100)
    );
  }, [searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.customerData && props.customerData.customerMobile) {
      getDataReports();
    }
  }, [page, props.handleSearch]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    getBankList();
    // getEkoBankList();
    navigator.geolocation.getCurrentPosition((data) => {
      setLatitude(data.coords.latitude);
      setLongitude(data.coords.longitude);
      console.log("response.data-----------", data.coords);
    });
    // setIsDownloadCsv(isDownloadCsv ? true : false);
  }, [props.customerData]); // eslint-disable-line react-hooks/exhaustive-deps

  // const handleImport = () => {
  //     setImportModal(true);
  // }

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: "250px 0" }}>
        <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
      </div>
    );
  }

  return (
    <div>
      <div className=" pt-2 pb-5">
        <div className="col-md-12">
          <div className="row pb-3">
            <div className="col-md-6 date-search">
              <div className="row">
                <div className="input-group">
                  <input
                    className="form-control py-2 border-right-0 border"
                    type="search"
                    defaultValue={searchText}
                    value={searchText}
                    onKeyDown={isNumber}
                    placeholder="Search Account Number..."
                    maxLength={20}
                    onChange={(e) => handleSearch(e)}
                  />
                  <span className="input-group-append">
                    <button
                      className="btn btn-outline-secondary border-left-0 border"
                      type="button"
                      onClick={() => getDataReports()}
                    >
                      <i className="fa fa-search" />
                    </button>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6 p-0">
              <div className="float-sm-right">
                {/* <button type="button" className="btn btn-primary mr-2" onClick={() => handleImport()}>
                                    <i className="fa fa-users"></i> Import
                                </button> */}
                <button
                  type="button"
                  className="btn btn-primary mr-2"
                  onClick={() => handleSyncBeneficiary()}
                >
                  <i className="fa fa-users"></i> View Beneficiary
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => addBane()}
                >
                  <i className="fa fa-user"></i> Add Beneficiary
                </button>
              </div>
            </div>
          </div>

          <div className="box-body">
            <DataTable
              columns={columns}
              data={getData.docs}
              // progressPending={getData.length > 0 ? false : true}
              highlightOnHover
              pagination
              paginationServer
              paginationTotalRows={getData.totalDocs}
              onChangeRowsPerPage={getDataReports}
              onChangePage={handlePageChange}
            />
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        limit={2}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {isAddBaneModal && (
        <Modal
          title={"Add Beneficiary"}
          width={400}
          open={isAddBaneModal}
          onOk={() => addBaneSave()}
          onCancel={handleHideModal}
          okText={"Submit"}
          cancelText={"Cancel"}
        >
          <div className="row">
            <div className="form-group col-lg-12 col-md-12">
              <label>Account Holder Mobile</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    placeholder="Mobile Number"
                    onChange={(e) => onChangeAddBene(e)}
                    autoComplete="off"
                    value={getBeneData.mobile}
                    maxLength={10}
                    onKeyDown={isNumber}
                  />
                </div>
              </div>
              {getBeneError && getBeneError.mobile && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>
            <div className="form-group col-lg-12 col-md-12">
              <label>Account Holder Name</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    placeholder="Account Holder Name"
                    onChange={(e) => onChangeAddBeneName(e)}
                    autoComplete="off"
                    value={getBeneData && getBeneData.name}
                    maxLength={20}
                  />
                </div>
              </div>
              {getBeneError && getBeneError.name && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>
            <div className="form-group col-lg-12 col-md-12">
              <label>Bank Name</label>
              <div className="input-group">
                <div className="custom-file">
                  <Select
                    options={getBankListData}
                    className={`normal-light w-100`}
                    defaultValue={selectedOption}
                    classNamePrefix="select"
                    placeholder="Select Bank"
                    name="mode"
                    onChange={(e) => onChangeBankIfscCode(e.value)}
                  />
                </div>
              </div>
            </div>
            <div className="form-group col-lg-12 col-md-12">
              <label>Global IFSC Code</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="ifscCode"
                    placeholder="Enter IFSC Code"
                    onChange={(e) => enterIfscCode(e)}
                    autoComplete="off"
                    readOnly={isIfscEnable}
                    value={getBeneData.ifscCode}
                    maxLength={11}
                  />
                  <div
                    className="inputgrouptext cursor-pointer text-success"
                    onClick={() =>
                      onChangeIfscCode(getBeneData && getBeneData.ifscCode)
                    }
                  >
                    Verify Branch
                  </div>
                </div>
              </div>
              {getBeneError && getBeneError.ifscCode && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>
            {getDataField &&
              getDataField.address &&
              getDataField.bankName &&
              getDataField.branchAddress &&
              getDataField.city &&
              getDataField.state && (
                <div className="form-group col-lg-12 col-md-12">
                  <div className="custom-file">
                    <ul>
                      <li>
                        Address: <strong>{getDataField.address}</strong>
                      </li>
                      <li>
                        Bank Name: <strong>{getDataField.bankName}</strong>
                      </li>
                      <li>
                        Branch Address:{" "}
                        <strong>{getDataField.branchAddress}</strong>
                      </li>
                      <li>
                        City: <strong>{getDataField.city}</strong>
                      </li>
                      <li>
                        State: <strong>{getDataField.state}</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            <div className="form-group col-lg-12 col-md-12">
              <label>Account Number</label>
              <div className="input-group">
                <div className="custom-file">
                  <input
                    type="text"
                    className="form-control"
                    name="accountNumber"
                    placeholder="Account Number"
                    onChange={(e) => onChangeAddBene(e)}
                    autoComplete="off"
                    value={getBeneData.accountNumber}
                    maxLength={20}
                  />
                  <button
                    className={`inputgrouptext cursor-pointer text-success`}
                    onClick={() => getBankNameFromAccountNumber()}
                  >
                    {GET_NAME}
                  </button>
                </div>
              </div>
              {getBeneError && getBeneError.accountNumber && (
                <span className="error text-danger">The field is required</span>
              )}
            </div>
            {getBeneData.beneBankName && (
              <div className="form-group col-lg-12 col-md-12">
                <label>Bene Bank Name</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      autoComplete="off"
                      value={getBeneData.beneBankName}
                      maxLength={20}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}

      {isSendMoneyModal && (
        <Modal
          title={"Money Transfer Verification"}
          width={600}
          open={isSendMoneyModal}
          onOk={() => handleSave(isSelectedUser)}
          onCancel={handleHideModal}
          okText={"Continue"}
          cancelText={"Cancel"}
        >
          <div className="row">
            <div className="col-md-12 form-group d-flex">
              <div className="col-md-8">
                <div>
                  {" "}
                  Bank Name : <strong>{isSelectedUser.bankName}</strong>
                </div>
                <div>
                  {" "}
                  IFSC Code : <strong>{isSelectedUser.ifscCode}</strong>
                </div>
                <div>
                  {" "}
                  Account Number :{" "}
                  <strong>{isSelectedUser.accountNumber}</strong>
                </div>
                <div>
                  {" "}
                  Customer Name : <strong>{isSelectedUser.beneName}</strong>
                </div>

                <div>
                  {" "}
                  Account Limit : <strong>{beneAccountLimit}</strong>
                </div>
              </div>
              {/* <div className='col-md-4'>
                            {chargesData && <><div> Service Charge : <strong>{chargesData.serviceAmount}</strong></div>
                                <div> Commission : <strong>{chargesData.commissionAmount}</strong></div>
                                <div> TDS : <strong>{chargesData.tdsAmount}</strong></div></>}
                        </div> */}
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="relation">Select Relation:</label>
              <br />
              <select
                id="relation"
                value={selectedRelation}
                onChange={(e) => setSelectedRelation(e.target.value)}
                style={{ padding: "8px", marginTop: "5px", width: "250px" }}
              >
                <option value="">Friend</option>
                {relations.map((relation, index) => (
                  <option key={index} value={relation}>
                    {relation}
                  </option>
                ))}
              </select>

              {selectedRelation && (
                <p style={{ marginTop: "10px" }}>
                  You selected: <strong>{selectedRelation}</strong>
                </p>
              )}
            </div>

            <div className="col-md-12 form-group">
              {/* <label>
                Mode: <strong className="text-danger">NEFT</strong>
              </label> */}

              <label>Mode:</label>

              <br />
              <Radio.Group
                defaultValue={4} // Set the default value for uncontrolled behavior
                buttonStyle="solid"
                onChange={onChangeChannel} // Will still trigger when selection changes
                optionType="button"
              >
                <Radio.Button value={4}>NEFT</Radio.Button>
                <Radio.Button value={5}>IMPS</Radio.Button>
              </Radio.Group>
            </div>
            <div className="col-md-12 form-group">
              <label>Confirm Amount: </label>
              <input
                type="text"
                name="amount"
                className="form-group form-control"
                value={sendMoneyAmount}
                onChange={(e) => handleAmount(e)}
                onKeyDown={isNumber}
                maxLength={5}
                placeholder="Confirm Amount"
              />
            </div>
          </div>
        </Modal>
      )}

      {invoiceDataModal && (
        <Modal
          open={invoiceDataModal}
          width={800}
          footer={false}
          onCancel={handleInvoiceModal}
          closable={false}
        >
          <PayoutInvoice
            transactionId={invoiceData && invoiceData.transactionId}
          />
        </Modal>
      )}

      {aadharVerifyModal && (
        <Modal
          title={"Aadhaar Verification Detail"}
          width={600}
          open={aadharVerifyModal}
          onOk={() => {
            setAadharVerifyDetail({});
            setAadharVerifyModal(false);
          }}
          onCancel={() => {
            setAadharVerifyDetail({});
            setAadharVerifyModal(false);
          }}
          okText={"Ok"}
          cancelText={"Cancel"}
        >
          <div className="row">
            <div className="col-md-12 form-group">
              <div>
                {" "}
                Name :{" "}
                <strong>
                  {aadharVerifyDetail && aadharVerifyDetail.data.nameAtBank}
                </strong>
              </div>
              {/* <div> Account Status : <strong>{aadharVerifyDetail && aadharVerifyDetail.accountStatus}</strong></div> */}
              {/* <div> Bank Name : <strong>{aadharVerifyDetail && aadharVerifyDetail.data.bankName}</strong></div>
                        <div> refId : <strong>{aadharVerifyDetail && aadharVerifyDetail.data.refId}</strong></div>
                        <div> City : <strong>{aadharVerifyDetail && aadharVerifyDetail.data.city}</strong></div>
                        <div> Branch : <strong>{aadharVerifyDetail && aadharVerifyDetail.data.branch}</strong></div> */}

              <div>
                {aadharVerifyDetail &&
                aadharVerifyDetail.accountStatus === "VALID" ? (
                  <p className="text-bold text-success">
                    {aadharVerifyDetail && aadharVerifyDetail.message}
                  </p>
                ) : (
                  <p className="text-bold text-danger">
                    {aadharVerifyDetail && aadharVerifyDetail.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Beneficiarylist;
